import angular from 'angular';
import {
  loaderService,
  orgDataService,
  userService,
} from 'app/services';
import {
  alerts,
  importDocument,
  actionIcon,
  sorting,
} from 'app/components/global';
import releaseProduct from './releaseProduct';
import ReleaseProductsController from './release-products.controller';
import directive from './release-products.directive';

export const routeConfig = {
  template: require('./release-products.html'),
  controller: 'ReleaseProductsController',
  controllerAs: 'releaseProductsVM',
};

export default angular.module('app.components.support.releaseProducts', [
  alerts,
  actionIcon,
  importDocument,
  sorting,
  loaderService,
  orgDataService,
  userService,
  releaseProduct
])
  .directive('releaseProducts', directive)
  .controller('ReleaseProductsController', ReleaseProductsController)
  .name;

console.log('app.components.support.releaseProducts created');
